import { existsSync, mkdirSync, appendFile } from "fs";
import debug, { Debugger } from "debug";

export class FileLogger {
	static DEFAULT_RELATIVE_FILE_LOCATION = "";
	static PREFIX_SEPARATOR = ":";
	static INFO_PREFIX = "info";
	static ERROR_PREFIX = "error";

	prefix: string;
	fileName: string;
	fileLocation: string;
	normalDebug: boolean;
	debug: Debugger;
	infoDebug: Debugger;
	errorDebug: Debugger;
	completeFileLocation: string;
	completeFilePath: string;

	constructor(fileName: string, prefix: string, normalDebug: boolean, fileLocation: string) {
		this.fileName = fileName;
		this.prefix = prefix;
		this.fileLocation = fileLocation;
		this.normalDebug = normalDebug;
		if (this.normalDebug) {
			// Create a debugger
			this.debug = debug(this.prefix);
			// Bind normal debugger to normal stdout
			this.debug.log = console.log.bind(console);
			// Create an info debugger
			this.infoDebug = this.debug.extend(FileLogger.INFO_PREFIX);
			// Bind info debugger to info stdout
			this.infoDebug.log = console.info.bind(console);
			// Create an error debugger
			this.errorDebug = this.debug.extend(FileLogger.ERROR_PREFIX);
			// Bind error debugger to error stdout
			this.infoDebug.log = console.error.bind(console);
		}
		this.completeFileLocation = `${process.env.API_LOG_LOCATION_PATH}${this.fileLocation}`;
		this.completeFilePath = `${this.completeFileLocation}${this.fileName}.log`;
		this.createLocation(this.completeFileLocation);
	}

	createLocation(path: string) {
		if (!existsSync(path))
			mkdirSync(path, { recursive: true });
	}

	log(...content: string[]) {
		const timeStamp = new Date().toLocaleString("es-ar");
		content.forEach(contentString => {
			appendFile(this.completeFilePath, `[${this.prefix}] ${timeStamp}: ${contentString}\n`, () => null);
			if (this.normalDebug) this.debug(contentString);
		});
	}

	info(content: string, appendPrefix = true) {
		const timeStamp = new Date().toLocaleString("es-ar");
		const prefix = appendPrefix ? `${this.prefix}${FileLogger.PREFIX_SEPARATOR}${FileLogger.INFO_PREFIX}` : this.prefix;
		appendFile(this.completeFilePath, `[${prefix}] ${timeStamp}: ${content}\n`, () => null);
		if (this.normalDebug) this.infoDebug(content);
	}

	error(content: string | null, error: any, appendPrefix = true) {
		const timeStamp = new Date().toLocaleString("es-ar");
		const prefix = appendPrefix ? `${this.prefix}${FileLogger.PREFIX_SEPARATOR}${FileLogger.ERROR_PREFIX}` : this.prefix;
		const message = `[${prefix}] ${timeStamp}: ${content}\n` +
			(error && (
				`[${prefix}] ${timeStamp}: ERROR: ${error}\n` +
				`[${prefix}] ${timeStamp}: ERROR MESSAGE: ${error?.message ?? ""}\n` +
				`[${prefix}] ${timeStamp}: ERROR TO STRING: ${error?.toString()}\n` +
				`[${prefix}] ${timeStamp}: ERROR TO JSON: ${JSON.stringify(error)}\n`
			));
		appendFile(this.completeFilePath, message, () => null);
		if (this.normalDebug) {
			this.errorDebug(content);
			if (error)
				this.errorDebug(error);
		}
	}

	extend(prefix: string) {
		const newPrefix = `${this.prefix}${FileLogger.PREFIX_SEPARATOR}${prefix}`;
		return new FileLogger(this.fileName, newPrefix, this.normalDebug, this.fileLocation);
	}
}